export default "__VITE_ASSET__BKPahRK7__"